var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"grecaptcha",attrs:{"id":_vm.uniqueIdentifier}})
}
var staticRenderFns = []

export { render, staticRenderFns }